export const setPhone = (payload) => {
  return {
    type: "SET_PHONE_OTP",
    payload: payload,
  };
};

export const setSendMethod = (payload) => {
  return {
    type: "SET_SEND_METHOD",
    payload: payload,
  };
};
